import React, { useState } from "react";
import { airlineLogo } from "@/lib/api";

export const AirlineLogo = ({ code, name, className = "w-10 h-10" }) => {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <div className={`${className} rounded-lg bg-brand/10 text-brand flex items-center justify-center font-heading font-bold text-xs`}>
        {code}
      </div>
    );
  }
  return (
    <img
      src={airlineLogo(code)}
      alt={name || code}
      onError={() => setErr(true)}
      className={`${className} rounded-lg object-contain bg-white border border-slate-100`}
    />
  );
};
